// Timer Type Attribute
export enum EKwikUIButtonApiCallTimerType {
  INCREMENT = "INCREMENT",
  DECREMENT = "DECREMENT"
}

export type TKwikUIButtonApiCallTimerType =
  | EKwikUIButtonApiCallTimerType.INCREMENT
  | EKwikUIButtonApiCallTimerType.DECREMENT;

export enum EKwikUIButtonApiCallTimerFormat {
  ss = "ss",
  SS = "SS",
  mm = "mm",
  MM = "MM",
  mm_ss = "mm:ss",
  MM_SS = "MM_SS",
  hh = "hh",
  HH = "HH",
  hh_mm = "hh:mm",
  HH_MM = "HH_MM",
  hh_mm_ss = "hh:mm:ss",
  HH_MM_SS = "HH_MM_SS",
  DAYS = "DAYS",
  DAYS_HH = "DAYS_HH",
  DAYS_HH_MM = "DAYS_HH_MM",
  DAYS_HH_MM_SS = "DAYS_HH_MM_SS",
  WEEKS = "WEEKS",
  WEEKS_DAYS = "WEEKS_DAYS",
  WEEKS_DAYS_HH = "WEEKS_DAYS_HH",
  WEEKS_DAYS_HH_MM = "WEEKS_DAYS_HH_MM",
  MONTHS = "MONTHS",
  MONTHS_DAYS = "MONTHS_DAYS_HH_MM",
  MONTHS_DAYS_HH = "MONTHS_DAYS_HH_MM",
  MONTHS_DAYS_HH_MM = "MONTHS_DAYS_HH_MM",
  MONTHS_DAYS_HH_MM_SS = "MONTHS_DAYS_HH_MM_SS",
  YEARS = "YEARS",
  YEARS_WEEKS = "YEARS_WEEKS",
  YEARS_WEEKS_DAYS = "YEARS_WEEKS_DAYS",
  YEARS_WEEKS_DAYS_HH = "YEARS_WEEKS_DAYS_HH",
  YEARS_WEEKS_DAYS_HH_MM = "YEARS_WEEKS_DAYS_HH_MM",
  YEARS_WEEKS_DAYS_HH_MM_SS = "YEARS_WEEKS_DAYS_HH_MM_SS",
  YEARS_MONTHS = "YEARS_MONTHS",
  YEARS_MONTHS_DAYS = "YEARS_MONTHS_DAYS",
  YEARS_MONTHS_DAYS_HH = "YEARS_MONTHS_DAYS_HH",
  YEARS_MONTHS_DAYS_HH_MM = "YEARS_MONTHS_DAYS_HH_MM",
  YEARS_MONTHS_DAYS_HH_MM_SS = "YEARS_MONTHS_DAYS_HH_MM_SS"
}

export type TKwikUIButtonApiCallTimerFormat =
  | EKwikUIButtonApiCallTimerFormat.ss
  | EKwikUIButtonApiCallTimerFormat.SS
  | EKwikUIButtonApiCallTimerFormat.mm
  | EKwikUIButtonApiCallTimerFormat.MM
  | EKwikUIButtonApiCallTimerFormat.mm_ss
  | EKwikUIButtonApiCallTimerFormat.MM_SS
  | EKwikUIButtonApiCallTimerFormat.hh
  | EKwikUIButtonApiCallTimerFormat.hh_mm
  | EKwikUIButtonApiCallTimerFormat.hh_mm_ss
  | EKwikUIButtonApiCallTimerFormat.HH
  | EKwikUIButtonApiCallTimerFormat.HH_MM
  | EKwikUIButtonApiCallTimerFormat.HH_MM_SS
  | EKwikUIButtonApiCallTimerFormat.DAYS
  | EKwikUIButtonApiCallTimerFormat.DAYS_HH
  | EKwikUIButtonApiCallTimerFormat.DAYS_HH_MM
  | EKwikUIButtonApiCallTimerFormat.DAYS_HH_MM_SS
  | EKwikUIButtonApiCallTimerFormat.WEEKS
  | EKwikUIButtonApiCallTimerFormat.WEEKS_DAYS
  | EKwikUIButtonApiCallTimerFormat.WEEKS_DAYS_HH
  | EKwikUIButtonApiCallTimerFormat.WEEKS_DAYS_HH_MM
  | EKwikUIButtonApiCallTimerFormat.MONTHS
  | EKwikUIButtonApiCallTimerFormat.MONTHS_DAYS
  | EKwikUIButtonApiCallTimerFormat.MONTHS_DAYS_HH
  | EKwikUIButtonApiCallTimerFormat.MONTHS_DAYS_HH_MM
  | EKwikUIButtonApiCallTimerFormat.MONTHS_DAYS_HH_MM_SS
  | EKwikUIButtonApiCallTimerFormat.YEARS
  | EKwikUIButtonApiCallTimerFormat.YEARS_WEEKS
  | EKwikUIButtonApiCallTimerFormat.YEARS_WEEKS_DAYS
  | EKwikUIButtonApiCallTimerFormat.YEARS_WEEKS_DAYS_HH
  | EKwikUIButtonApiCallTimerFormat.YEARS_WEEKS_DAYS_HH_MM
  | EKwikUIButtonApiCallTimerFormat.YEARS_WEEKS_DAYS_HH_MM_SS
  | EKwikUIButtonApiCallTimerFormat.YEARS_MONTHS
  | EKwikUIButtonApiCallTimerFormat.YEARS_MONTHS_DAYS
  | EKwikUIButtonApiCallTimerFormat.YEARS_MONTHS_DAYS_HH
  | EKwikUIButtonApiCallTimerFormat.YEARS_MONTHS_DAYS_HH_MM
  | EKwikUIButtonApiCallTimerFormat.YEARS_MONTHS_DAYS_HH_MM_SS;

export type TKwikUIButtonApiCallTimer = {
  maxTime: number;
  messageWithTimerPlaceholder: string;
  timerChangeType: TKwikUIButtonApiCallTimerType;
  timeFormat: TKwikUIButtonApiCallTimerFormat;
  timerStep: number;
};
